/* eslint-disable no-return-await */
/* eslint-disable no-shadow */
import React, { useEffect, useState } from 'react'
import TotalHighRangePage from 'src/pages/ReportsPages/ReportsBoard/MarketShareReportsPages/TotalHighRangePage'
import boardReportsService from 'src/services/boardReportsService'

const MarkertHighRangeCompany = () => {
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [totalHighRange, setTotalHighRange] = useState([])
  const [totalHighRangeSegment, setTotalHighRangeSegment] = useState([])
  const [gTotalHighRangeA, setGTotalHighRangeA] = useState([])
  const [gTotalHighRangeB, setGTotalHighRangeB] = useState([])

  const handleDateChange = value => {
    setSelectedDate(value)
  }

  const reloadComponents = async () => {
    const [
      totalHighRange,
      totalHighRangeSegment,
      gTotalHighRangeA,
      gTotalHighRangeB,
    ] = await Promise.all([
      boardReportsService.getTotalMarketShare('3', selectedDate.getFullYear(), 'subcategoria=ALTA GAMA'),
      boardReportsService.getTotalMarketShare('4', selectedDate.getFullYear(), 'subcategoria=ALTA GAMA'),
      boardReportsService.getTotalMarketShareGraphics('4a', selectedDate.getFullYear(), 'subcategoria=ALTA GAMA'),
      boardReportsService.getTotalMarketShareGraphics('4b', selectedDate.getFullYear(), 'subcategoria=ALTA GAMA'),
    ])
    setTotalHighRange(totalHighRange)
    setTotalHighRangeSegment(totalHighRangeSegment)
    setGTotalHighRangeA(gTotalHighRangeA)
    setGTotalHighRangeB(gTotalHighRangeB)
  }

  useEffect(() => {
    reloadComponents()
  }, [selectedDate])


  return (
    <TotalHighRangePage
      handleDateChange={handleDateChange}
      selectedDate={selectedDate}
      totalHighRange={totalHighRange}
      totalHighRangeSegment={totalHighRangeSegment}
      gTotalHighRangeA={gTotalHighRangeA}
      gTotalHighRangeB={gTotalHighRangeB}
    />
  )
}

export default MarkertHighRangeCompany
